// import Highcharts from "highcharts/highstock";
import CAMCFundAsset from "./camc-fund-asset-portfolio";

class WebsiteFundAssetPortfolio extends CAMCFundAsset {
    constructor(fundCode, chartContainer) {
        super(fundCode);
        this.$root = $(".tabs-content-amc.asset-allocation");
        this.chartContainer = chartContainer;
        this.bindEvents();
    }
    bindEvents() {
        $(window).on("resize", () => {
            if (this.pieChart) {
                this.pieChart.reflow();
            }
        });
    }

    setEmptyMessage(container = "#asset-allocation-container") {
        let $containerObj = this.$root.find(container);
        if ($containerObj) {
            $containerObj.empty();
            $containerObj.append('<div class="api-messaging-content grid-x align-center-middle">暂无数据显示</div>');
            $(`${container} .container-updatetime-portfolio`).text("");
        }
    }

    errorHandler() {
        showApiMessageing(null);
        this.setEmptyMessage("#asset-allocation-container");
    }

    updateFundDate(date) {
        this.$root.find("#asset-allocation-container .container-updatetime-portfolio").text("数据截止日期：" + date);
    }

    createPieChart(assetDataArray) {
        var options = {
            chart: {
                spacing: [0, 0, 0, 0],
                renderTo: this.chartContainer,
                type: "pie",
                marginRight: 15,
                marginTop: 15,
                marginLeft: 15,
                marginBottom: 15,
                animation: false,
                reflow: true,
                style: {
                    fontFamily: "neuzeit_grotesk, Noto Sans SC, Noto Sans CJK SC, sans-serif ",
                },
            },
            colors: [
                "#EA6A19",
                "#018BC8",
                "#FFC000",
                "#61B815",
                "#841B8F",
                "#515B6B",
                "#17B8B8",
                "#A2D830",
                "#9F968D",
                "#42BDEA",
                "#BEE46E",
            ],

            tooltip: {
                useHTML: true,
                percentageDecimals: 2,
                formatter: function () {
                    return (
                        '<div class="tooltop" style="font-size:15px;"><div style="margin:5px 5px 5px 5px;">' +
                        this.point.name +
                        "<br />" +
                        '<div style="display:flex"><div class="circle" style="margin-top:7px;margin-right:7px;background:' +
                        this.point.color +
                        ';"></div><div>' +
                        this.series.name +
                        ": <b>" +
                        Highcharts.numberFormat(this.y).replace(",", " ") +
                        "%</b></div></div></div></div>"
                    );
                },
            },

            legend: {
                enabled: true,
                align: "left",
                floating: true,
                x: 3,
            },
            plotOptions: {
                pie: {
                    allowPointSelect: false,
                    cursor: "pointer",
                    // showInLegend: true,
                    dataLabels: {
                        enabled: false,
                    },
                    point: {
                        events: {
                            mouseOver: function (e) {
                                $(e.target.legendItem.element).trigger("mouseover");
                            },
                            mouseOut: function (e) {
                                $(e.target.legendItem.element).trigger("mouseout");
                            },
                        },
                    },
                    states: {
                        inactive: {
                            enabled: false,
                        },
                    },
                },
            },
            series: [{}],

            credits: {
                enabled: false,
            },
            title: {
                text: "",
            },
            events: {
                load: function (event) {
                    event.target.reflow();
                },
            },
        };

        var asset,
            assetReal = [],
            otherArray = [],
            otherValue = 0;
        asset = assetDataArray;
        asset.sort(function (a, b) {
            return b[1] - a[1];
        });

        for (var a = 0; a < asset.length; a++) {
            if (a < 10) {
                assetReal.push(asset[a]);
            } else {
                var arrAsset = asset[a];
                otherValue += Number(arrAsset[1]);
            }
        }
        if (otherValue != 0) {
            assetReal.push(["其他", otherValue]);
        }

        // assetReal.concat(otherArray);
        options.series[0].data = assetReal;
        options.series[0].innerSize = "60%";
        options.series[0].name = "占基金总资产的比例";
        options.series[0].type = "pie";
        options.series[0].showInLegend = true;
        options.series[0].animation = false;
        let pieChart;
        const _this = this;
        pieChart = Highcharts.chart(this.chartContainer, options, function (chart) {
            var $legend = _this.$root.find("#asset-allocation-container-table");
            var divNum = $legend.children().length;
            if (divNum == 0) {
                $legend.append(
                    '<div class="item-title item-title--chart"><div class="series series__name">资产类型</div><div  class="series series__percent"><div>占基金总资产的比例</div></div></div>',
                );
                $.each(chart.series[0].data, function (j, data) {
                    $legend.append(
                        '<div class="item item--chart" style="box-shadow: inset 4px 0 0 0 ' +
                            data.color +
                            '"><div class="series series__name">' +
                            data.name +
                            '</div><div class="series series__percent">' +
                            Highcharts.numberFormat(data.y).replace(",", " ") +
                            "%</div></div>",
                    );
                });
                $legend.append(`<div class="item-hint">${assetAllocationDisclaimer}</div>`);
            }

            _this.$root.find("#asset-allocation-container-table .item").mouseover(function () {
                var inx = $(this).index() - 1,
                    point = pieChart.series[0].points[inx];
                var items = _this.$root.find("#asset-allocation-container-table .item");
                var styleContainer = items[inx].style["box-shadow"];
                var newStyleContainer = styleContainer.replace(/4px/, "8px");
                items[inx].style.setProperty("box-shadow", newStyleContainer);

                for (var i = 0; i < items.length; i++) {
                    if (i != inx) {
                        var styleContainerClick = items[i].style["box-shadow"];
                        var newStyleContainerClick = styleContainerClick.replace(/8px/, "4px");
                        items[i].style.setProperty("box-shadow", newStyleContainerClick);
                    }
                    var point1 = pieChart.series[0].points[i];
                    $(point1.legendItem.element).trigger("mouseout");
                }
                $(point.legendItem.element).trigger("mouseover");
            });

            _this.$root.find("#asset-allocation-container-table .item").mouseout(function () {
                var items = _this.$root.find("#asset-allocation-container-table .item");
                for (var i = 0; i < items.length; i++) {
                    var styleContainerClick = items[i].style["box-shadow"];
                    var newStyleContainerClick = styleContainerClick.replace(/8px/, "4px");
                    items[i].style.setProperty("box-shadow", newStyleContainerClick);
                    var point1 = pieChart.series[0].points[i];
                    $(point1.legendItem.element).trigger("mouseout");
                }
            });
            //refolow the chart , if the chart is over size
            if (chart.chartWidth > 510) {
                chart.setSize(510, 430);
            }
        });
        this.pieChart = pieChart;
    }
}

$(function () {
    let assentAllocation = $("#asset-allocation-container-chart");
    if (window.fundCode && assentAllocation.length) {
        // $("#asset-allocation-container").show();
        const camcFundAsset = new WebsiteFundAssetPortfolio(window.fundCode, "asset-allocation-container-chart");
        camcFundAsset.render();
    }
});
